import Bus from "./Bus.js";
import accordion from "./accordion.vue";
import expandable from "./expandable.vue";
import searchBar from "./searchBar.vue";
import Map from "./leaflet/src/components/Map.vue";
import TileLayer from "./leaflet/src/components/TileLayer.vue";
import Marker from "./leaflet/src/components/Marker.vue";
import Popup from "./leaflet/src/components/Popup.vue";
import searchGrid from "./searchGrid.vue";
import searchMap from "./searchMap.vue";

const App = {
  el: "#primary",

  components: {
    "v-map": Map,
    "v-tilelayer": TileLayer,
    "v-marker": Marker,
    "v-popup": Popup,
    searchGrid,
    searchBar,
    searchMap,
    accordion,
    expandable
  },

  data: {
    message: "Blank"
  },

  methods: {}
};

module.exports = App;

